module.exports = __webpack_public_path__ + "static/boston_static-8fe87600303c2cda02b7dfafed9914d4.png";